import { ImageComponent } from '../../../../components/Image';

const commonGemImageProps = {
  fill: true,
  sizes: '100%, 100%',
  alt: 'gem',
};

const BluredGemsPack = () => (
  <>
    <div className="bluredPink">
      <ImageComponent
        src="/jackpot/decor/bluredPink.png"
        {...commonGemImageProps}
      />
    </div>

    <div className="bluredBlue">
      <ImageComponent
        src="/jackpot/decor/bluredBlue.png"
        {...commonGemImageProps}
      />
    </div>

    <div className="bluredGreen">
      <ImageComponent
        src="/jackpot/decor/bluredGreen.png"
        {...commonGemImageProps}
      />
    </div>
  </>
);

export const JackpotGemsDefaultPack = () => (
  <>
    <div className="pink">
      <ImageComponent src="/jackpot/decor/pink.png" {...commonGemImageProps} />
    </div>

    <div className="blue">
      <ImageComponent src="/jackpot/decor/blue.png" {...commonGemImageProps} />
    </div>

    <div className="green">
      <ImageComponent src="/jackpot/decor/green.png" {...commonGemImageProps} />
    </div>

    <BluredGemsPack />
  </>
);

export const JackpotGemsWinPack = () => (
  <>
    <div className="blueWithConfetti">
      <ImageComponent
        src="/jackpot/decor/blueWithConfetti.png"
        {...commonGemImageProps}
      />
    </div>
    <div className="pinkWithConfetti">
      <ImageComponent
        src="/jackpot/decor/pinkWithConfetti.png"
        {...commonGemImageProps}
      />
    </div>
    <div className="greenWithConfetti">
      <ImageComponent
        src="/jackpot/decor/greenWithConfetti.png"
        {...commonGemImageProps}
      />
    </div>
    <div className="multipleConfetti">
      <ImageComponent
        src="/jackpot/decor/multipleConfetti.png"
        {...commonGemImageProps}
      />
    </div>
    <div className="singleConfetti">
      <ImageComponent
        src="/jackpot/decor/singleConfetti.png"
        {...commonGemImageProps}
      />
    </div>

    <BluredGemsPack />
  </>
);
